module.exports = __webpack_public_path__ + "static/card-dba6d5cafdd4ca5200b4f190f52b8d73.jpg";